<template>
  <a-modal title="91家纺网代发合作协议"
           :visible="isShow"
           :footer="null"
           width="625px"
           @cancel="cancel"
           centered
           class="basic_wrapper">
    <p>温馨提示：为了充分保障您的利益，请您务必在提交订单前仔细阅读以下告知事项和《91家纺网代发服务协议》。阅读过程中，如果您不同意其中任何约定，您应当立即停止提交订单。您提交订单，即视为您已完全知晓、理解和接受本协议的所有条款，并受其约束。</p>
    <h6>代发下单须知</h6>
    <dl>
      <dt>1、服务性质</dt>
      <dd>
        <p>鉴于91家纺网为B2B电商平台，本协议所指的代发服务是为91家纺网平台会员提供的代拿、代发货物的服务。</p>
        <p>注：根据《电子商务法》，您应当向91家纺网提交身份证、地址、联系方式、行政许可证等真实信息，以便91家纺网进行核验、登记，建立登记档案，并定期核验更新。</p>
      </dd>
      <dt>2、包装、物流选择</dt>
      <dd>在代发过程中，商家不提供商品打包所需的包装及物流服务商，您下单时请根据购买商品选择合适的包装及物流服务商，91家纺网将会根据您提交的订单信息进行发货操作。</dd>
      <dd>代发服务人员在打包发货过程中，若出现您选择的包装与商品不匹配时（主要体现在，包装偏大、偏小等情况），代发服务人员会根据商品的大小调换包装，若因修改包装而产生包装金额变动，系统会自动计算相应费用。若修改后包装金额增加，则由系统直接从您的账户扣除；若包装金额减少，则由系统直接将差价退还至您的91家纺网余额账户。</dd>
      <dd>代发服务人员在打包发货过程中，若出现您选择的物流服务商的服务范围和计费标准与实际情况不匹配时（主要体现在偏远地区该物流服务商不配送）若因修改物流服务商而产生运费金额变动，系统会自动计算相应费用。若修改后运费金额增加，运费金额差价小于等于20元，则由系统直接从您的账户扣除；运费金额差价大于20元，代发服务人员会通知您并根据您的决定进行后续操作，具体操作方法请与91家纺网客服联络。若运费金额减少，则由系统直接将差价退还至您的91家纺网余额账户。</dd>
      <dt>3、退货结果</dt>
      <dd>如果您选择退货，91家纺网会在批发市场退货规则的基础之上，向供应商争取好的退货结果，但91家纺网不对退货结果负责。</dd>
      <dt>4、退货失败寄回</dt>
      <dd>由于91家纺网不设仓储服务，对于退货失败的商品，您若未在系统通知您退货失败后的30日内在系统内或向客服提出认领申请，91家纺网有权对该商品进行报废处理。报废后的商品将无法找回，91家纺网对此不承担任何责任。</dd>
      <dt>5、退货原因选择</dt>
      <dd>您在申请退货时，请选择正确的退货原因并附上详细说明。因退货原因选择错误导致91家纺网无法认定责任的，91家纺有权拒绝退货及赔付。</dd>
      <dt>6、退货要求</dt>
      <dd>如果您申请91家纺网进行责任赔偿认定的，必须在寄回退货商品时保留商品的原标签。因标签缺失导致仓库无法认定责任的，91家纺网有权拒绝退货及赔付。</dd>
      <dt>7、退货申请时限</dt>
      <dd>为了保护您的合法权益，91家纺网建议您在订单发出后的7日内申请退货。若因为您超时提交退货申请导致91家纺网无法认定责任的，91家纺网有权拒绝任何形式的退货及赔付。</dd>
    </dl>
    <h6>91家纺网代发服务协议</h6>
    <dl>
      <dt>尊敬的用户：</dt>
      <dd>
        <p>非常感谢您选择91家纺网代发服务。</p>
        <p>在您提交代发订单之前，请认真阅读91家纺网的服务条款。当您通过91家纺官方网站提交代发订单，即表示您已全部阅读、知晓、理解和接受91家纺网制定的关于拿货、发货、退货服务及后期纠纷处理规则，并受其约束。相关规则包括本协议及91家纺网官网发布的服务条款。</p>
      </dd>
    </dl>
    <h6>第一条 91家纺网拿货服务细则</h6>
    <dl>
      <dt>1.1 货品品质</dt>
      <dd>您了解91家纺网平台上的商品信息是商家自行发布，不同供应商商品价格、质量水平不一。91家纺网代发服务负责按照您下单的信息拿货、代发货，无法控制货品质量，您须自行度量和承担购买风险。</dd>
      <dt>1.2 服务范围</dt>
      <dd>91家纺网代发服务的拿货范围包括：海门市叠石桥及周边、南通市微供市场及周边、南通市纺都城及周边等以南通市大岛酒店为中心方圆5公里区域内的91家纺网已合作且开通代发服务的平台商户。</dd>
      <dt>1.3 拿货时间</dt>
      <dd>91家纺网每天将根据订单情况，从上午9:00--16:00到相应供货商拿货。91家纺网对您当天16:00前提交的订单将尽可能在当日安排拿货、发货。若因节假日、电商大促或其他原因导致交易量大增、待拿商品过多、商家商品缺货等，您需要理解会有部分商品拿货延时并不追究任何责任。</dd>
      <dt>1.4 下单信息</dt>
      <dd>91家纺网默认按照您下单时填写的商品信息代为拿货、发货，若因您下单提交的信息有误，造成的后果需自行承担。</dd>
      <dt>1.5 货不对版</dt>
      <dd>您应当理解，因供货商备货能力参差不齐，可能出现将商品装错袋、贴错货号的情况。未购买质检的商品，91家纺网代发服务只会在拿货的时候检查外包装是否完整，并不负责核对图片与实物的差异。若出现货不对版或其他质量问题，需要您自行联系商家处理，91家纺网不承担任何赔偿责任。</dd>
      <dt>1.6 商品缺货</dt>
      <dd>若您提交订单后供货商出现缺货的情况，您可以选择等待补货、取消订单或以同款商品替代。若您未及时选择处理方法，91家纺网将默认为于供货商承诺的到货日为您补货（商品下架、供货商未出货等特殊情况除外）。若您选择以同款商品替代，则您需要自行寻找心仪的供货商和同款商品，并重新提交商品信息，具体操作方法请与91家纺网客服联络。若因您寻找同款商品延误时间导致您的买家取消订单，由此造成的您的任何损失由您自行承担，91家纺网不承担任何赔偿责任。</dd>
      <dt>1.7开票事项</dt>
      <dd>91家纺网平台上的商品价格为不含税价格，若您需要对代发订单中的商品价款开具发票，您应直接与相应的平台商户联系开票事宜，且相应税款、发票邮寄费均由您自行承担。</dd>
      <dd>若您需要对代发订单中的包装耗材费、快递费、有偿选择的质检费开具发票，您可与91家纺网平台客服联系开票事宜。若选择纸质发票，则发票邮寄费由您自行承担。</dd>
    </dl>
    <h6>第二条 91家纺网质检、发货服务规则</h6>
    <dl>
      <dt>2.1 质检项目</dt>
      <dd>
        <p>91家纺网代发服务为您提供严格、有偿的质检服务。您可以在提交订单时自愿勾选该项服务，并承担相应的费用；如果您提交订单时勾选了该项服务的，无论您后期选择取消订单或退货，质检服务的费用均不予退还。本协议中所涉的所有“质检”服务均适用本条款约定。</p>
        <p>质检内容包括：</p>
        <p>1） 脏污：检测代发商品是否有脏污的地方</p>
        <p>2） 质量：检测代发商品是否存在破损情况</p>
        <p>3） 工艺：检测代发商品是否有比较大的开线</p>
        <p>4） 发漏：检测代发商品是否存在零件缺失的情况</p>
        <p>注：您应理解，若代发商品存在任何不属于上述范围中的质量问题，91家纺网不承担任何形式的赔偿责任。</p>
      </dd>
      <dt>2.2 发货时间</dt>
      <dd>当91家纺网拿齐您下单的货物后，物流服务商一般会在当日对代发商品进行揽收，不排除会有来不及收走的遗留件。若订单中的商品存在缺货的情况，需等待代发货品补齐后一并发出。您对此造成的延误理解并不追究责任。</dd>
      <dt>2.3 运费计算</dt>
      <dd>在您提交订单时，91家纺网会根据您的具体订单情况计算并收取运费。运费包括首重运费和续重运费，收费标准参照各家物流服务商提供的实际运费标准。您已经在91家纺官网“运费计算规则”板块查看和确认详细运费标准。</dd>
      <dt>2.4 单号获取</dt>
      <dd>在91家纺网订单审核后，系统将自动为您提供订单对应的快件物流单号，如涉及到部分地区该物流服务商不配送等情况，系统会根据您修改的新物流服务商重新提供对应的快件物流单号。</dd>
      <dt>2.5 收件信息错误</dt>
      <dd>若您在订单发货后，发现收件人信息有误，91家纺网可以按您更改的信息协助您通知物流服务商客服更改收件信息。由于各个物流服务商有其独立运行的系统，91家纺网只能起到信息传递作用，对各个物流服务商更改收件信息的时间和效力不做保证。</dd>
      <dt>2.6 物流异常</dt>
      <dd>
        <p>若91家纺网为您代发的快件，移交物流服务商后发生异常，处理办法如下：若快件物流信息未显示物流服务商已揽件，则91家纺网将与物流服务商核实，并在五个工作日内寻找并给出处理结论；若快件物流信息显示物流服务商已收件，则91家纺网将协助您对物流异常情况进行反馈。若您需要具体快件物流信息，请在91家纺网订单详情页查看。</p>
        <p>注：目前91家纺网针对在91家纺网仓库内部进行的关键操作环节都设置了摄像头进行监控，监控视频保存期限为一个月，超过一个月91家纺网将不予处理，您对此知晓，并理解和接受由此产生的所有后果。如果发生类似丢件的争议事件，请您尽快联系客服处理，以便91家纺网核实责任归属、解决问题。</p>
      </dd>
    </dl>
    <h6>第三条 修改/取消订单、退货服务规则</h6>
    <dl>
      <dt>3.1 修改订单</dt>
      <dd>若您提交的订单在系统显示中处于已发货状态之前（包含待付款、未拿货、拿货中、缺货、下架、未拿全、已拿货等状态下），您可以对订单进行修改。若订单修改涉及到价格的调整（比如修改后同款商品费用不一致或者修改后减少商品数量），则您需要在您已支付金额的基础上多退少补。若系统显示订单商品已处于已备货或送定制状态（送定制状态是指91家纺网为您提供的修改尺寸或者打款给商家定做等定制服务），那么您不可以再对订单商品进行修改。若系统显示订单已处于已发货状态，那么您不可以再对订单进行修改。您对此知晓，并理解和接受由此产生的所有后果。若您有任何问题，请联系客服。</dd>
      <dt>3.2 取消订单</dt>
      <dd>若您提交的订单在系统显示中处于已发货状态之前（包含待付款、未拿货、拿货中、缺货、下架、未拿全、已拿货等状态下），您随时可以选择取消订单，91家纺网将依约在次日将该订单相应商品金额退至您在91家纺网平台的资金账户中。若系统显示订单商品已处于已备货或送定制状态（送定制状态是指91家纺网为您提供的修改尺寸或者打款给商家定做等定制服务），91家纺网将在已备货商品退至商户，且系统收到商家的退款后，依约在次日将将该订单相应商品金额退至您在91家纺网平台的资金账户中。若系统显示订单已处于已发货状态，那么您不可以再取消订单。您对此知晓，并理解和接受由此产生的所有后果。若您有任何问题，请联系客服。</dd>
      <dt>3.3 退货申请</dt>
      <dd>若您的客户对收到的商品不满意，在不影响二次销售的情况下，您可以在91家纺网对该订单发起退货申请，并提交正确的货物退回的快递信息。同时，您需要承担退货手续费，退货手续费将从已支付的商品货款中扣除。若您未按程序提交退货申请（申请订单信息混淆、快递单号信息错误、退货商品有误等），91家纺网不提供退货服务，由此造成的任何损失由您自行承担。</dd>
      <dt>3.4 退货结果</dt>
      <dd>您提交退货申请后，最终是否退货取决于供货商，您在下单时可以根据商品售后属性（正常退换、只换不退、不换不退、非质量问题不换不退）进行判断。只要在满足市场退货政策（包括但不限于商品未下架、商品非活动款、不影响二次销售等情况）的前提下，详细规则请您自行查看帮助中心或咨询客服，91家纺网会协助您与供应商进行协商，但退货结果仍需要您与供货商共同协商确认，91家纺网不对是否退货以及退货结果负责。由此造成的您的任何损失由您自行承担，91家纺网不承担任何赔偿责任。</dd>
      <dt>3.5 退货价格</dt>
      <dd>由于代发服务周期原因，存在的变数较大，市场交易存在风险，经常会发生退货价低于原价的情况，91家纺网退货员会竭尽所能为您争取全额退款。若无法按照拿货价格退货，则由您自行决定是否退货。</dd>
      <dt>3.6 退货失败或无退货订单信息</dt>
      <dd>对于退货失败或者无退货订单信息的包裹，您可以在系统内或向客服提出认领申请。由于商品存放产生的仓储费用昂贵，对于退货失败的商品，或者寄到91家纺网仓库，但无法查找到对应退货订单信息、且无人认领的包裹，自快递签收之日起，91家纺网将为您免费保管30天。30天之后若您还未认领退货失败的商品，视为您放弃对该商品的所有权。91家纺网有权对退货失败的商品集中进行报废处理。报废后的商品将无法找回，对此91家纺网不承担任何责任。您对此知晓，并理解和接受由此产生的所有后果。</dd>
    </dl>
    <h6>第四条 售后服务及纠纷处理规则</h6>
    <dl>
      <dt>4.1 91家纺网责任认定</dt>
      <dd>
        <p>1、若您已选择质检服务（参见本协议2.1条），您需要退货的商品明确属于以下情况，91家纺网将承担货物退回及正确货物寄出产生的全部运费（货物退回运费赔偿支持可送达前提下的最优惠的物流服务商）</p>
        <p>1） 脏污：代发商品有脏污的地方</p>
        <p>2） 质量：代发商品存在破损情况</p>
        <p>3） 工艺：代发商品有比较大的开线</p>
        <p>4） 发漏：代发商品存在缺失（套装缺少零件等）</p>
      </dd>
      <dd>2、若您未选择质检服务，由于91家纺网分拣错误导致的退货，91家纺网将承担货物退回及正确货物寄出产生的全部运费。</dd>
      <dd>3、若您未选择质检服务，因商家备货出错导致的退货，91家纺网将尽力协助您与对应商户进行协商，帮助退货，但91家纺网不对退货结果保证。</dd>
     <dt>4.2 售后申请流程</dt>
     <dd>只有在91家纺网系统显示您的客户签收了商品之后，您才可以在91家纺网发起售后（退货）申请。91家纺网接到退件后，会于3个工作日内将商品送至供货商退货，由供货商鉴定是否人为损坏后，方可确认退货责任归属。对属于本协议4.1条所示的91家纺网责任的，将由91家纺网承担相应的责任。若退货责任应由供货商承担的，91家纺网将协助您与供货商进行协商，但91家纺网不承担任何形式的赔偿责任。</dd>
     <dt>4.3 纠纷赔偿</dt>
     <dd>收到您的退件后，只有书面约定退货责任应由91家纺网承担的，91家纺网才承担相应的赔偿责任。赔偿标准根据问题的类型和责任的归属而存在不同，详情请咨询客服。</dd>
    </dl>
    <h6>第五条 第三方纠纷处理</h6>
    <dl>
      <dt>5.1 快递物流服务商</dt>
      <dd>快件物流信息显示快递物流服务商已收件后，若快件物流信息发生异常，91家纺网将向您提供物流服务商的联系方式，并协助您对物流异常情况进行反馈。关于您与快递物流服务商之间的纠纷，91家纺网不承担任何责任，但会根据您的需求提供交易记录相应的证据材料。</dd>
      <dt>5.2 供应商、下游顾客</dt>
      <dd>由于91家纺网代发服务仅提供劳务服务，无法为您的代发行为做出任何决策，因此若您与供货商和下游顾客出现纠纷，91家纺网不承担任何责任，但会根据您的需求提供交易记录相应的证据材料。若您未在91家纺网完成交易，与供货商线下交易而出现纠纷，91家纺网不承担任何责任。</dd>
    </dl>
  </a-modal>
</template>

<script>
export default {
  name: 'DropProtocolModal',
  model: {
    prop: 'isShow',
    event: 'hidden'
  },
  props: {
    isShow: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    cancel () {
      this.$emit('hidden', false)
    }
  }
}
</script>
<style scoped>
::v-deep .ant-modal-header {
  text-align: center;
  background: #fff7e3;
}
::v-deep .ant-modal-body {
  max-height: 400px;
  overflow-y: auto;
}

.basic_wrapper p,
.basic_wrapper dt,
.basic_wrapper dd,
.basic_wrapper h6 {
  font-size: 12px;
  /* line-height: 18px; */
}

.basic_wrapper h6 {
  margin-top: 20px;
}
.basic_wrapper dt:nth-of-type(n + 2) {
  margin-top: 15px;
}

.basic_wrapper dt + dd:nth-of-type(n + 2) {
  margin-top: 0;
}
.basic_wrapper dd:nth-of-type(n + 2) {
  margin-top: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/common/order/DropProtocolModal.vue